import React, { useEffect, useState } from 'react';
import { View, TextInput, StyleSheet } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const FreeText = ({handleText, defaultAnswer = null}) => {
  const [text, setText] = useState('');

  const onChangeText=(text: string)=>{
    setText(text);
  } 
  
  const onHandleInputText=()=>{
    if(handleText){
      handleText(text);
    }
  }

  const onClearText = () => {
    setText('');
  };

  useEffect(()=>{
      if(defaultAnswer && defaultAnswer.values){
        onChangeText(defaultAnswer.values[0])
      }
    },[])

  return (
    <View style={styles.inputWrapper}>
      <TextInput style={styles.textField}
        value={text}
        onChangeText={(text)=>onChangeText(text)}
        onBlur={onHandleInputText}
        autoFocus={false}
        placeholder='Hãy nêu ý kiến của bạn'
        placeholderTextColor={'#666666'}
        multiline={true}
        maxLength={300}
      />
    </View>
  );
};


const styles = StyleSheet.create({
    inputWrapper:{
      backgroundColor:'#FFFFFF',
      height:150
    },
    textField:{
      padding:10,
      marginTop:15,
      height:125,
      borderRadius: 10,
      borderColor:'#444444',
      borderWidth:1,
      textAlignVertical:'top',
      fontFamily:FONT_STYLE.MEDIUM,
      fontSize:14
    }
})
export default FreeText;
